import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import ArticleIcon from '@mui/icons-material/Article';
import ProfilePicture from '../assets/images/profile-picture.jpg'
import '../assets/styles/Main.scss';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={ProfilePicture} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/Kaylin-NormanSlack" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/kaylinnormanslack/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="https://docs.google.com/document/d/1c-o45RFqcSfxSrFb9horSgVbMDf7Pa5ntR6zEh7ao2g/edit?usp=sharing" target="_blank" rel="noreferrer"><ArticleIcon/></a>
          </div>
          <div className="mobile_social_icons">
            <a href="https://github.com/Kaylin-NormanSlack" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/kaylinnormanslack/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="https://docs.google.com/document/d/1c-o45RFqcSfxSrFb9horSgVbMDf7Pa5ntR6zEh7ao2g/edit?usp=sharing" target="_blank" rel="noreferrer"><ArticleIcon/></a>
          </div>
          <h1>Kaylin Norman-Slack</h1>
          <p>SDET | Quality. Automation. Impact!</p>
          <p>Building reliable software through automation, quality engineering, and collaboration.</p>
        </div>
      </div>
    </div>
  );
}

export default Main;